const environment = {
    apiUrl: process.env.REACT_APP_API_URL,
    secretSoftwareKey: process.env.REACT_APP_SECRET_SOFTWARE_KEY,
    environment: process.env.REACT_APP_ENV,
    debug: process.env.REACT_APP_DEBUG === 'true',
    dev_username: process.env.REACT_APP_USERNAME,
    dev_password: process.env.REACT_APP_PASSWORD
};

export default environment;
